import React from "react";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SchedulingStateType from "../../enums/robot/rsw/scheduling-state-type";
import ActiveScheduleIcon from "../../components/CommandHub/ActiveScheduleIcon";
import PendingScheduleIcon from "../../components/CommandHub/PendingScheduleIcon";
import InactiveScheduleIcon from "../../components/CommandHub/InactiveScheduleIcon";
import InterruptedByUserIcon from "../../components/CommandHub/InterruptedByUserIcon";
import InterruptedByErrorIcon from "../../components/CommandHub/InterruptedByErrorIcon";

const SchedulingIcon: React.FC<{
  schedulingStateType?: SchedulingStateType;
  altColor?: "disabled" | "primary" | "inherit" | "action" | "secondary" | "error" | "info" | "success" | "warning";
}> = ({ schedulingStateType, altColor: color = "primary" }) => {
  switch (schedulingStateType) {
    case SchedulingStateType.Active:
      return <ActiveScheduleIcon color={color} fontSize="medium" />;
    case SchedulingStateType.Pending:
      return <PendingScheduleIcon color={color} fontSize="medium" />;
    case SchedulingStateType.Inactive:
      return <InactiveScheduleIcon color={color !== "primary" ? color : "disabled"} fontSize="medium" />;
    case SchedulingStateType.InterruptedByUser:
      return <InterruptedByUserIcon color={color} fontSize="medium" />;
    case SchedulingStateType.InterruptedByError:
    case SchedulingStateType.InterruptedByMaintenance:
      return <InterruptedByErrorIcon color={color} fontSize="medium" />;
    case SchedulingStateType.Ignored:
      return <CheckCircleOutlineRoundedIcon color={color} fontSize="medium" />;
    case SchedulingStateType.Unknown:
    default:
      return null;
  }
};

export default SchedulingIcon;
